export default __webpack_public_path__ + "static/media/hhs-qld-central-queensland.1ca27ab6.svg";